<template>
    <div id="saas-app">
        <router-view />
    </div>
</template>

<script>
export default {
    name: 'App',
    data() {
        return {
            isLoading: true
        };
    },
    methods: {}
};
</script>

<style scoped lang="scss">
#saas-app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100%;
}
</style>
